import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { DataSource } from '@angular/cdk/collections';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/merge';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/debounceTime';
import { OpcionModel } from '../Global/Opcion.model';
import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';
import { CierreMesModel } from './CierreMes.model';
import { MatSnackBar } from '@angular/material';
import { DataTableBodyCellComponent } from '@swimlane/ngx-datatable';
import { IfObservable } from 'rxjs/observable/IfObservable';


@Component({
    selector: 'CierreMes',
	templateUrl: './CierreMes.component.html',
	styleUrls: ['../../../../styles.css']
})

/**
* @author Michael
* @since  22/04/2019
**/
export class CierreMes {

	public form: FormGroup;
	public formErrors: any;

    public mes: string;
	public nano: string;
    public fechaUltimoCierre:Date;
    public fechaMesSiguienteUltimoCierre:Date;
    public fechaParametros:Date;
    
	public guardando: boolean = true;

	myControl = new FormControl();
	filteredOptions: Observable<OpcionModel[]>;
	

	public btnConsultar: boolean;

    public ocultar: boolean = false;
	public mensaje: string = "";

	constructor(private formBuilder: FormBuilder, private _serviciosGenerales: ServiciosGenerales, public snackBar: MatSnackBar,
		private _route: ActivatedRoute, private _router: Router, public dialog: MatDialog) {

            this.formErrors = {
                mes: {},
                nano: {}
            };

            this.snackBar.dismiss(); 
		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.btnConsultar = _serviciosGenerales.seguridad.isConsultar();
		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
	}


    ngOnInit() {
        this.inicializarFormulario();
    }

	onFormValuesChanged() {
		for (const field in this.formErrors) {
			if (!this.formErrors.hasOwnProperty(field)) {
				continue;
			}

			// Clear previous errors
			this.formErrors[field] = {};

			// Get the control
			const control = this.form.get(field);

			if (control && control.dirty && !control.valid) {
				this.formErrors[field] = control.errors;
			}
		}
	}

	openSnackBar(message: string, action: string) {
		this.snackBar.open(message, action, {
			duration: 20000
		});
	}

    openSnackBarEspecial(message: string, action: string) {
		let snackBarRef =  this.snackBar.open(message, action);

		snackBarRef.onAction().subscribe(() => {

			this.ocultar = false;
			this.mensaje = "";
		});
		
		let shand = document.getElementsByClassName('mat-snack-bar-container') as HTMLCollectionOf<HTMLElement>;		
		
		if (shand.length != 0) {
			    for (let i=0;i<shand.length;i++){
				shand[i].style.backgroundColor = "rgb(255 204 214)";
				}
			}
	}


    inicializarFormulario() {
        
        this._serviciosGenerales.get('fechaUltimoCierreVictimas', {}).subscribe(
            result => {

                for (var x of result) {
                    this.fechaUltimoCierre = new Date(x.fecha);
                }
            },
            error => {
                var errorMensaje = <any>error;
                console.log('Error al enviar la peticion ', errorMensaje);

            });

            
        this._serviciosGenerales.get('fechaMesSiguienteUltimoCierre', {}).subscribe(
            result => {

                for (var x of result) {
                    this.fechaMesSiguienteUltimoCierre = new Date(x.fecha);
                }
            },
            error => {
                var errorMensaje = <any>error;
                console.log('Error al enviar la peticion ', errorMensaje);

            });

		this.form = this.formBuilder.group({
            mes: ['', Validators.required],
            nano: ['', Validators.required]
		});

		this.form.valueChanges.subscribe(() => {
			this.onFormValuesChanged();
		});
    }

    
    cierreMes(){
    this.guardando=false;

        //console.log("fecha desde:",new Date(this.fechaDesde).toISOString().substr(0, 10)," fecha hasta:",new Date(this.fechaHasta).toISOString().substr(0, 10)," Valor:",this.valorRendimientos)
        this.fechaParametros = new Date(this.mes+'/01/'+this.nano);
        console.log('Fecha Armada con parametros ingresados',this.fechaParametros,'-----',this.fechaUltimoCierre);


        if(this.fechaParametros <= this.fechaUltimoCierre){
            this.openSnackBarEspecial('No se puede realizar el proceso de Cierre con los datos ingresados porque la fecha del ultimo cierre es mayor o porque el mes ya se encuentra cerrado.', 'X');
            this.guardando=true;
            return;
        }

        if(this.fechaParametros >= this.fechaMesSiguienteUltimoCierre){
            this.openSnackBarEspecial('No se puede realizar el proceso de Cierre con los datos ingresados porque el mes es superior ó igual 2 meses al ultimo cierre', 'X');
            this.guardando=true;
            return;
        }

        let parametros = {
                           MES : this.mes,
                           NANO : this.nano.toString(),
                           VUSUARIO: this._serviciosGenerales.seguridad.getInfoSesion().usuario
                        };
        
        this._serviciosGenerales.get('procedure/PRC_CIERRE_MES', parametros).subscribe(
            result => {
                console.log(result);

                if (result.error == true || result.mensaje.toUpperCase().indexOf('OK') == -1) {
                    this.openSnackBarEspecial(result.mensaje, "X");
                    this.guardando = true;
                    return;
                } else {
                    this.form.reset();
                    this.form.clearAsyncValidators();
                    this.form.clearValidators();
                    this.inicializarFormulario();
                    this.openSnackBar('Cierre de Mes correctamente: '+result.mensaje.replace('OK',''), "X");
                }
                this.guardando = true;
            }, error => {
                var errorMensaje = <any>error;
                console.log('Error al enviar la peticion ', errorMensaje);
                this.openSnackBarEspecial("No se logró obtener la respuesta del servidor, por favor verificar si se efectuó este proceso.", "X");
                this.guardando = true;
            })
    }




    bloquearBoton(){
		var count = 1;
		this.cierreMes();
	}
    
}





// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/CierreMes/CierreMes.component.ts